import {memo, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import useRequireAuth from "@/hooks/useRequireAuth";
import {useAuthStore} from "../../../store/useAuth.store";
import {avatarImages} from "../../../util/avatarUtils";
import styles from "./TopReferrals.module.css";

const MOCK_REFERRALS = [
  {name: "rafael", total: 18},
  {name: "maria", total: 15},
  {name: "carlos", total: 12},
  {name: "juan", total: 10},
  {name: "lucas", total: 8},
];

const RANK_STYLES = [styles.rankGold, styles.rankSilver, styles.rankBronze];

const getAvatarForName = name => {
  let hash = 0;
  for (const ch of name) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return avatarImages[Math.abs(hash) % avatarImages.length];
};

const ReferralRow = memo(({name, total, rank, onNavigate}) => (
  <div
    className={styles.row}
    onClick={() => onNavigate(name)}
    onKeyDown={e => (e.key === "Enter" || e.key === " ") && onNavigate(name)}
    role="link"
    tabIndex={0}
    aria-label={`Ver perfil de ${name}`}
  >
    <span className={`${styles.rank} ${RANK_STYLES[rank - 1] || ""}`}>{rank}</span>
    <div className={styles.avatar}>
      <img
        src={getAvatarForName(name)}
        alt={name}
        className={styles.avatarImg}
        loading="lazy"
        onError={e => {
          e.currentTarget.style.display = "none";
          e.currentTarget.nextElementSibling.style.display = "flex";
        }}
      />
      <span
        className={styles.avatarFallback}
        style={{display: "none"}}
      >
        {name.charAt(0).toUpperCase()}
      </span>
    </div>
    <span className={styles.userName}>{name}</span>
    <span className={styles.refCount}>
      <span className={styles.refNumber}>{total}</span> referidos
    </span>
  </div>
));

ReferralRow.displayName = "ReferralRow";

const TopReferrals = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const requireAuth = useRequireAuth();
  const goToProfile = username => requireAuth(() => navigate(`/u/${username}`));

  const handleInvite = useCallback(() => {
    if (authStatus === "authenticated") {
      navigate("/user/referrals");
      return;
    }
    useAuthStore.getState().handleAuthForm("registration");
    useAuthStore.getState().handleShowAuthModal();
  }, [authStatus, navigate]);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span
          className={styles.headerIcon}
          role="img"
          aria-label="trophy"
        >
          🏆
        </span>
        <h3 className={styles.headerTitle}>Top Referidos</h3>
      </div>
      <div className={styles.list}>
        {MOCK_REFERRALS.map((r, i) => (
          <ReferralRow
            key={r.name}
            {...r}
            rank={i + 1}
            onNavigate={goToProfile}
          />
        ))}
      </div>
      <button
        type="button"
        className={styles.inviteButton}
        onClick={handleInvite}
        aria-label="Invitar a un amigo al programa de referidos"
      >
        Invitar a un amigo
      </button>
    </div>
  );
};

export default memo(TopReferrals);
